//import IFCFileLoader from '../IFC/[Deprecated]IFCFileLoader.js';
import {loadFile} from "../IFC/IFCFileLoadHandler.js"
import { ifcMeshPlacer } from "../IFC/IFCMeshHandler.js";
import { meshBvhIndexer } from "../IFC/BoundingVolumeHierarchy.js";
import Experience from "../Experience.js";
import ThreeJSFunctions from "../Threejs/ThreeJSFunctions.js";
import { asyncFitOrthoPerCameraToCenteredObject } from "../Threejs/ThreeJSFunctions.js";

import { ReturnMeshAsGroup } from "../IFC/IFCMeshHandler.js";

let experience = null;



export default class FileInputChangeListener {
    constructor() {

        if (!experience) {
            experience = new Experience();
        }
        
        const fileInput = document.getElementById('fileInput');
        const popupModal = document.getElementById('popupModal');
        const popupForm = document.getElementById('popupForm');
        const fileTypeSwitch = document.getElementById('fileTypeSwitch');
        const fileTypeLabel = document.getElementById('fileTypeLabel');

        //const ifcFileLoader = new IFCFileLoader();

        if (fileInput) {
            fileInput.addEventListener('change', async (event) => {
                const file = event.target.files[0];
                if (file) {

                    // Show the popup modal
                    popupModal.style.display = 'flex';

                    // Update label based on switch state
                    fileTypeSwitch.addEventListener('change', () => {
                        fileTypeLabel.textContent = fileTypeSwitch.checked
                            ? "Installation"
                            : "Construction";
                    });

                    // Wait for the user to confirm
                    popupForm.onsubmit = async (e) => {
                        e.preventDefault(); // Prevent default form submission

                        // Get the selected file type
                        const selectedType = fileTypeSwitch.checked
                            ? "Installation"
                            : "Construction";

                        // Hide the modal
                        popupModal.style.display = 'none';
                        // Proceed with file loading
                      
                        //await ifcFileLoader.loadFile(file, selectedType);
                        await loadFile(file, selectedType)
                        await meshBvhIndexer()
                        await ifcMeshPlacer()
                        //console.log(experience.world.world.camera)
                        //console.log(experience)
                        
                        
                    

                        fileTypeSwitch.checked = false;
                        fileTypeLabel.textContent = fileTypeSwitch.checked
                        ? "Installation"
                        : "Construction";




                    };

                }


            });

            
        } else {
            console.error("File input not found in the DOM");
        }
    }
}






